import React from 'react'
import Drawer from "react-drag-drawer";
import PirateBoy from '../../assets/images/new/pirate.png'
import PlayStore from '../../assets/images/new/google-button.png'
import AppStore from '../../assets/images/new/apple-button.png'

const DownloadAppModal = (props) => {
  return (
    <Drawer
      direction="bottom"
      open={props.opened}
      dontApplyListeners={true}
      onRequestClose={() => { }}
      containerElementClass="px-6"
      modalElementClass="fixed left-0 top-0"
    >
      <div className='w-screen h-screen overflow-hidden py-8 px-4 flex flex-col justify-center items-center bg-modal-secondary'>
        <div className='w-full max-w-sm h-full md:h-auto flex flex-col p-6 border-4 border-yellow-primary rounded-3xl relative pt-6 md:pt-4 pb-60 sm:pb-52 md:pb-64'>
          <p className='text-2xl font-bold text-center text-yellow-primary mb-4'>Baixe o app do<br />Conta Outra Vez!<br />para ter a melhor<br />experiência!</p>

          <p className='text-xl text-center text-white'>Acesse online</p>
          <p className='text-xl text-center text-white'>e offline</p>
          <p className='text-xl text-center text-white'>Leia seus livros</p>
          <p className='text-xl text-center text-white'>quando quiser e</p>
          <p className='text-xl text-center text-white'>guarde-os para</p>
          <p className='text-xl text-center text-white'>sempre</p>

          <div className='flex flex-row justify-center items-center gap-4 text-center mt-8'>
            <a href="https://play.google.com/store/apps/details?id=br.com.gravioladigital.cov" className='flex flex-1 md:w-32'>
              <img src={PlayStore} alt="Botão Playstore" />
            </a>

            <a href="https://apps.apple.com/us/app/conta-outra-vez/id6742466034" className='flex flex-1 md:w-32'>
              <img src={AppStore} alt="Botão Appstore" />
            </a>
          </div>

          <div className='w-full px-8 mt-4'>
            <button className='w-full h-12 bg-yellow-primary rounded-full border-0 font-bold' onClick={props.close}>
              continuar no site
            </button>
          </div>

          <div className='mt-4 flex flex-1 flex-col overflow-visible relative'>
            <img src={PirateBoy} alt="Garoto Pirata" className='absolute top-0 left-0 scale-50' />
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default DownloadAppModal